import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "etq-inspector"
  }, [!_vm.element ? _c('div', {
    staticClass: "inspector-empty"
  }, [_vm._m(0), _c('h6', [_vm._v("Selecione um elemento")]), _c('p', [_vm._v(" Clique em algo na etiqueta para ajustar conteúdo, tamanho e aparência. ")])]) : [_c('div', {
    staticClass: "inspector-header"
  }, [_c('div', {
    staticClass: "min-w-0"
  }, [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Elemento selecionado")]), _c('input', {
    staticClass: "element-name",
    attrs: {
      "maxlength": "80",
      "aria-label": "Nome do elemento"
    },
    domProps: {
      "value": _vm.element.nome
    },
    on: {
      "change": function change($event) {
        return _vm.set('nome', $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "d-flex flex-shrink-0"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-icon btn-light mr-1",
    attrs: {
      "type": "button",
      "title": _vm.element.visivel === false ? 'Mostrar elemento' : 'Ocultar elemento'
    },
    on: {
      "click": function click($event) {
        return _vm.set('visivel', _vm.element.visivel === false);
      }
    }
  }, [_c('i', {
    class: _vm.element.visivel === false ? 'far fa-eye-slash' : 'far fa-eye'
  })]), _c('button', {
    staticClass: "btn btn-xs btn-icon btn-light mr-1",
    attrs: {
      "type": "button",
      "title": "Duplicar"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('duplicate');
      }
    }
  }, [_c('i', {
    staticClass: "far fa-copy"
  })]), _c('button', {
    staticClass: "btn btn-xs btn-icon btn-light-danger",
    attrs: {
      "type": "button",
      "title": "Remover"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('delete');
      }
    }
  }, [_c('i', {
    staticClass: "far fa-trash-alt"
  })])])]), _c('b-tabs', {
    attrs: {
      "pills": "",
      "nav-class": "inspector-tabs",
      "content-class": "pt-4",
      "small": "",
      "fill": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Conteúdo",
      "active": ""
    }
  }, [_vm.hasField ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Campo exibido")]), _c('select', {
    staticClass: "form-control form-control-sm",
    domProps: {
      "value": _vm.element.campo
    },
    on: {
      "change": function change($event) {
        return _vm.setField($event.target.value);
      }
    }
  }, _vm._l(_vm.fieldGroups, function (group) {
    return _c('optgroup', {
      key: group.name,
      attrs: {
        "label": group.name
      }
    }, _vm._l(group.fields, function (field) {
      return _c('option', {
        key: field.key,
        domProps: {
          "value": field.key
        }
      }, [_vm._v(" " + _vm._s(field.label) + " ")]);
    }), 0);
  }), 0)]) : _vm._e(), _vm.element.tipo === 'text' ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Texto")]), _c('textarea', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "rows": "3",
      "maxlength": "250",
      "placeholder": "Digite o conteúdo"
    },
    domProps: {
      "value": _vm.element.texto
    },
    on: {
      "input": function input($event) {
        return _vm.set('texto', $event.target.value);
      }
    }
  })]) : _vm._e(), _vm.hasField || _vm.element.tipo === 'text' ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Mostrar este elemento")]), _c('select', {
    staticClass: "form-control form-control-sm",
    domProps: {
      "value": _vm.element.exibir_quando
    },
    on: {
      "change": function change($event) {
        return _vm.set('exibir_quando', $event.target.value);
      }
    }
  }, _vm._l(_vm.displayRules, function (rule) {
    return _c('option', {
      key: rule.value,
      domProps: {
        "value": rule.value
      }
    }, [_vm._v(" " + _vm._s(rule.label) + " ")]);
  }), 0)]) : _vm._e(), _vm.element.tipo === 'barcode' ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo do código")]), _c('select', {
    staticClass: "form-control form-control-sm",
    domProps: {
      "value": _vm.get('codigo_barras.tipo', 'auto')
    },
    on: {
      "change": function change($event) {
        return _vm.set('codigo_barras.tipo', $event.target.value);
      }
    }
  }, _vm._l(_vm.barcodeTypes, function (type) {
    return _c('option', {
      key: type.value,
      domProps: {
        "value": type.value
      }
    }, [_vm._v(" " + _vm._s(type.label) + " ")]);
  }), 0)]), _c('label', {
    staticClass: "switch-row"
  }, [_c('span', [_c('strong', [_vm._v("Exibir número")]), _c('small', [_vm._v("Mostra o número abaixo das barras")])]), _c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "checked": _vm.get('codigo_barras.exibir_texto', true)
    },
    on: {
      "change": function change($event) {
        return _vm.set('codigo_barras.exibir_texto', $event);
      }
    }
  })], 1)] : _vm._e(), _vm.isSalePrice ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Modo de exibição")]), _c('select', {
    staticClass: "form-control form-control-sm",
    domProps: {
      "value": _vm.get('priceMode', 'cash')
    },
    on: {
      "change": function change($event) {
        return _vm.setPriceMode($event.target.value);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "cash"
    }
  }, [_vm._v("Somente à vista")]), _c('option', {
    attrs: {
      "value": "installment"
    }
  }, [_vm._v("Somente parcelado")]), _c('option', {
    attrs: {
      "value": "cash_installment"
    }
  }, [_vm._v("À vista + parcelado")])])]), _vm.priceModeHasInstallments ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantidade de parcelas")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "number",
      "min": "1",
      "step": "1"
    },
    domProps: {
      "value": _vm.get('installments', 3)
    },
    on: {
      "change": function change($event) {
        return _vm.setNumber('installments', $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Acréscimo no preço")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    domProps: {
      "value": _vm.get('installmentIncrease', 0)
    },
    on: {
      "change": function change($event) {
        return _vm.setNumber('installmentIncrease', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("%")])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Finalização do preço")]), _c('select', {
    staticClass: "form-control form-control-sm",
    domProps: {
      "value": _vm.get('commercialEnding', 'none')
    },
    on: {
      "change": function change($event) {
        return _vm.set('commercialEnding', $event.target.value);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Sem ajuste")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Terminar em 0")]), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Terminar em 9")])])])] : _vm._e()] : _vm._e(), _vm.hasTextFormat ? _c('div', {
    staticClass: "format-box"
  }, [_c('strong', [_vm._v("Formatação do valor")]), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-6 form-group mb-3"
  }, [_c('label', [_vm._v("Antes")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "Ex.: R$"
    },
    domProps: {
      "value": _vm.get('formato.prefixo', '')
    },
    on: {
      "input": function input($event) {
        return _vm.set('formato.prefixo', $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-6 form-group mb-3"
  }, [_c('label', [_vm._v("Depois")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "Ex.: /un"
    },
    domProps: {
      "value": _vm.get('formato.sufixo', '')
    },
    on: {
      "input": function input($event) {
        return _vm.set('formato.sufixo', $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group mb-3"
  }, [_c('label', [_vm._v("Maiúsculas e minúsculas")]), _c('select', {
    staticClass: "form-control form-control-sm",
    domProps: {
      "value": _vm.get('formato.transformacao', 'nenhuma')
    },
    on: {
      "change": function change($event) {
        return _vm.set('formato.transformacao', $event.target.value);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nenhuma"
    }
  }, [_vm._v("Manter como está")]), _c('option', {
    attrs: {
      "value": "maiusculas"
    }
  }, [_vm._v("TUDO MAIÚSCULO")]), _c('option', {
    attrs: {
      "value": "minusculas"
    }
  }, [_vm._v("tudo minúsculo")]), _c('option', {
    attrs: {
      "value": "capitalizar"
    }
  }, [_vm._v("Iniciais Maiúsculas")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 form-group mb-0"
  }, [_c('label', [_vm._v("Limite de caracteres")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "250"
    },
    domProps: {
      "value": _vm.get('formato.limite_caracteres', 0)
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('formato.limite_caracteres', $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-6 form-group mb-0"
  }, [_c('label', [_vm._v("Se estiver vazio")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "Não mostrar"
    },
    domProps: {
      "value": _vm.get('formato.texto_vazio', '')
    },
    on: {
      "input": function input($event) {
        return _vm.set('formato.texto_vazio', $event.target.value);
      }
    }
  })])])]) : _vm._e()], 2), _c('b-tab', {
    attrs: {
      "title": "Aparência"
    }
  }, [_vm.hasAppearance ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-7 form-group"
  }, [_c('label', [_vm._v("Fonte")]), _c('select', {
    staticClass: "form-control form-control-sm",
    domProps: {
      "value": _vm.get('estilo.fonte', 'dejavu_sans')
    },
    on: {
      "change": function change($event) {
        return _vm.set('estilo.fonte', $event.target.value);
      }
    }
  }, _vm._l(_vm.fonts, function (font) {
    return _c('option', {
      key: font.value,
      domProps: {
        "value": font.value
      }
    }, [_vm._v(" " + _vm._s(font.label) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "col-5 form-group"
  }, [_c('label', [_vm._v("Tamanho")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "4",
      "max": "72",
      "step": "0.5"
    },
    domProps: {
      "value": _vm.get('estilo.tamanho_pt', 8)
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('estilo.tamanho_pt', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("pt")])])])])]), _c('label', [_vm._v("Estilo do texto")]), _c('div', {
    staticClass: "style-toolbar mb-4"
  }, [_c('button', {
    class: {
      active: _vm.get('estilo.negrito', false)
    },
    attrs: {
      "type": "button",
      "title": "Negrito"
    },
    on: {
      "click": function click($event) {
        return _vm.toggle('estilo.negrito');
      }
    }
  }, [_c('strong', [_vm._v("B")])]), _c('button', {
    class: {
      active: _vm.get('estilo.italico', false)
    },
    attrs: {
      "type": "button",
      "title": "Itálico"
    },
    on: {
      "click": function click($event) {
        return _vm.toggle('estilo.italico');
      }
    }
  }, [_c('em', [_vm._v("I")])]), _c('button', {
    class: {
      active: _vm.get('estilo.sublinhado', false)
    },
    attrs: {
      "type": "button",
      "title": "Sublinhado"
    },
    on: {
      "click": function click($event) {
        return _vm.toggle('estilo.sublinhado');
      }
    }
  }, [_c('u', [_vm._v("U")])])]), _vm.hasContentAlignment ? _c('div', {
    staticClass: "content-alignment-box mb-4"
  }, [_c('div', {
    staticClass: "content-alignment-heading"
  }, [_c('strong', [_vm._v("Alinhamento dentro da caixa")]), _c('small', [_vm._v(" Ajusta o conteúdo sem mover a caixa na etiqueta. ")])]), _c('label', [_vm._v("Horizontal")]), _c('div', {
    staticClass: "alignment-toolbar mb-3"
  }, [_c('button', {
    staticClass: "content-align-left",
    class: {
      active: _vm.get('estilo.alinhamento', 'left') === 'left'
    },
    attrs: {
      "type": "button",
      "title": "Conteúdo à esquerda"
    },
    on: {
      "click": function click($event) {
        return _vm.set('estilo.alinhamento', 'left');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-align-left"
  }), _c('span', [_vm._v("Esquerda")])]), _c('button', {
    staticClass: "content-align-center",
    class: {
      active: _vm.get('estilo.alinhamento', 'left') === 'center'
    },
    attrs: {
      "type": "button",
      "title": "Conteúdo centralizado horizontalmente"
    },
    on: {
      "click": function click($event) {
        return _vm.set('estilo.alinhamento', 'center');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-align-center"
  }), _c('span', [_vm._v("Centro")])]), _c('button', {
    staticClass: "content-align-right",
    class: {
      active: _vm.get('estilo.alinhamento', 'left') === 'right'
    },
    attrs: {
      "type": "button",
      "title": "Conteúdo à direita"
    },
    on: {
      "click": function click($event) {
        return _vm.set('estilo.alinhamento', 'right');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-align-right"
  }), _c('span', [_vm._v("Direita")])])]), _c('label', [_vm._v("Vertical")]), _c('div', {
    staticClass: "alignment-toolbar"
  }, [_c('button', {
    staticClass: "content-align-top",
    class: {
      active: _vm.get('estilo.alinhamento_vertical', 'middle') === 'top'
    },
    attrs: {
      "type": "button",
      "title": "Conteúdo no topo"
    },
    on: {
      "click": function click($event) {
        return _vm.set('estilo.alinhamento_vertical', 'top');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  }), _c('span', [_vm._v("Topo")])]), _c('button', {
    staticClass: "content-align-middle",
    class: {
      active: _vm.get('estilo.alinhamento_vertical', 'middle') === 'middle'
    },
    attrs: {
      "type": "button",
      "title": "Conteúdo centralizado verticalmente"
    },
    on: {
      "click": function click($event) {
        return _vm.set('estilo.alinhamento_vertical', 'middle');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrows-alt-v"
  }), _c('span', [_vm._v("Centro")])]), _c('button', {
    staticClass: "content-align-bottom",
    class: {
      active: _vm.get('estilo.alinhamento_vertical', 'middle') === 'bottom'
    },
    attrs: {
      "type": "button",
      "title": "Conteúdo na base"
    },
    on: {
      "click": function click($event) {
        return _vm.set('estilo.alinhamento_vertical', 'bottom');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-down"
  }), _c('span', [_vm._v("Base")])])]), _c('small', {
    staticClass: "content-alignment-tip"
  }, [_vm._v(" Para mover ou centralizar a caixa inteira, use a aba Posição. ")])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 form-group"
  }, [_c('label', [_vm._v("Cor do texto")]), _c('div', {
    staticClass: "color-field"
  }, [_c('input', {
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": _vm.colorValue(_vm.get('estilo.cor', '#000000'))
    },
    on: {
      "input": function input($event) {
        _vm.set('estilo.cor', $event.target.value.toUpperCase());
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.colorValue(_vm.get("estilo.cor", "#000000"))))])])]), _c('div', {
    staticClass: "col-6 form-group"
  }, [_c('label', [_vm._v("Fundo")]), _c('div', {
    staticClass: "color-field"
  }, [_c('input', {
    attrs: {
      "type": "color",
      "disabled": _vm.get('estilo.fundo', 'transparent') === 'transparent'
    },
    domProps: {
      "value": _vm.colorValue(_vm.get('estilo.fundo', '#FFFFFF'))
    },
    on: {
      "input": function input($event) {
        _vm.set('estilo.fundo', $event.target.value.toUpperCase());
      }
    }
  }), _c('button', {
    staticClass: "transparent-toggle",
    class: {
      active: _vm.get('estilo.fundo', 'transparent') === 'transparent'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleTransparent
    }
  }, [_vm._v(" Sem fundo ")])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 form-group mb-0"
  }, [_c('label', [_vm._v("Borda")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.get('estilo.borda_mm', 0)
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('estilo.borda_mm', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])])])]), _c('div', {
    staticClass: "col-6 form-group mb-0"
  }, [_c('label', [_vm._v("Espaço interno")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "10",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.get('estilo.padding_mm', 0)
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('estilo.padding_mm', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])])])])])] : _c('div', {
    staticClass: "inspector-note"
  }, [_vm._v(" Este tipo de elemento usa somente posição, tamanho e cor de borda. ")])], 2), _c('b-tab', {
    attrs: {
      "title": "Posição"
    }
  }, [_c('div', {
    staticClass: "position-grid"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Esquerda (X)")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.element.x_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('x_mm', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Topo (Y)")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.element.y_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('y_mm', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Largura")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0.2",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.element.largura_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('largura_mm', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Altura")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0.2",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.element.altura_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('altura_mm', $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Rotação")]), _c('div', {
    staticClass: "rotation-buttons"
  }, _vm._l([0, 90, 180, 270], function (rotation) {
    return _c('button', {
      key: rotation,
      class: {
        active: Number(_vm.element.rotacao) === rotation
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.set('rotacao', rotation);
        }
      }
    }, [_vm._v(" " + _vm._s(rotation) + "° ")]);
  }), 0)]), _c('div', {
    staticClass: "position-actions"
  }, [_c('button', {
    staticClass: "center-horizontal-button btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('center-horizontal');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrows-alt-h mr-2"
  }), _vm._v("Centralizar horizontalmente ")]), _c('button', {
    staticClass: "center-vertical-button btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('center-vertical');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrows-alt-v mr-2"
  }), _vm._v("Centralizar verticalmente ")]), _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('front');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-layer-group mr-2"
  }), _vm._v("Trazer para frente ")])])])], 1)]], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "inspector-empty-icon"
  }, [_c('i', {
    staticClass: "fas fa-mouse-pointer"
  })]);
}];
export { render, staticRenderFns };